import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { RmEvaluationDto, RmEvaluationSamplesDto } from ".";

export class RmEvaluationResponse extends GlobalResponseObject{
    data?: RmEvaluationDto;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: RmEvaluationDto) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}